<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="1">
          <el-step
            :title="
              transportTypeCode == 'KY'
                ? $t('i18n_Air_Freight_Information')
                : transportTypeCode == 'HY'
                ? $t('i18n_ocean_freight_information')
                : transportTypeCode == 'LY'
                ? $t('i18n_land_transportation_information')
                : ''
            "
          ></el-step>
          <el-step :title="$t('i18n_Value_added_service')"></el-step>
          <el-step :title="$t('i18n_shipping_information')"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div style="display: flex; display: -webkit-flex; align-items: center">
          <img src="../../assets/style.png" alt="" />
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-left: 10px;
            "
          >
            {{ $t("i18n_Value_added_service") }}
          </p>
        </div>
        <div v-for="(item, index) in formData.feeItemDTOS" :key="index">
          <div class="Item_list" v-if="item.remark != '预估保费'">
            <div style="width: 100%" v-show="item.remark != '预估保费'">
              <el-checkbox
                v-model="item.checked"
                @change="handleChange(item)"
                >
                <!-- {{ item.feeName }} -->
                  <template v-if="item.feeCode === 'CLEF'">{{ $t('i18n_customs_declaration_with_tax_refund') }}</template>
                  <template v-else>{{ item.feeName }}</template>
                </el-checkbox
              >
            </div>
            <div
              class="LR_center"
              style="width: 100%; float: left"
              v-show="item.checked && item.feeCode != 'INS'"
            >
              <div
                class="count_center"
                style="padding: 25px 25px 0 25px; box-sizing: border-box"
              >
                <span style="float: left">{{ item.priceDesc }}</span>
                <div style="float: left; margin-left: 15px">
                  <el-input-number
                    size="mini"
                    v-model="item.num"
                    @change="handleChange(item)"
                    :min="1"
                    :max="9999"
                  ></el-input-number>
                </div>
              </div>

              <div style="padding: 25px 25px 0 25px; box-sizing: border-box">
                {{ $t("i18n_estimated_cost") }}：{{ item.currency
                }}{{ item.amount }}
              </div>
            </div>
            <!-- 保险无忧 -->
            <div
              class="LR_center_insurance"
              style="width: 100%; float: left"
              v-show="
                item.checked &&
                item.feeCode == 'INS' &&
                item.remark != '预估保费'
              "
            >
              <div class="LR_center_box">
                <el-form
                  :model="insuranceData"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="110px"
                >
                  <el-form-item
                    label="费用类型:"
                    prop="chargeType"
                    label-width="150px"
                  >
                    <el-input
                      disabled
                      style="width: 200px"
                      :title="insuranceData.chargeType"
                      v-model="insuranceData.chargeType"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    style="width: 350px"
                    label="保额比例:"
                    prop="insuredAmount"
                    label-width="150px"
                  >
                    <el-select
                      style="width: 200px"
                      v-model="insuranceData.insuredAmount"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in insuredAmountList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="品名:"
                    prop="goodsName"
                    label-width="150px"
                  >
                    <el-input
                      disabled
                      style="width: 200px"
                      :title="insuranceData.goodsName"
                      v-model="insuranceData.goodsName"
                      placeholder="请输入内容"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="箱数:" prop="amount" label-width="150px">
                    <el-input
                      disabled
                      style="width: 200px"
                      v-model="insuranceData.amount"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="PCS:"
                    prop="pcsAmount"
                    label-width="150px"
                  >
                    <el-input
                      style="width: 200px"
                      type="number"
                      v-model="insuranceData.pcsAmount"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单箱最低货值(CNY):"
                    prop="singleBoxMin"
                    label-width="150px"
                  >
                    <el-input
                      style="width: 200px"
                      type="number"
                      v-model.number="insuranceData.singleBoxMin"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单箱最高货值(CNY):"
                    prop="singleBoxMax"
                    label-width="150px"
                  >
                    <el-input
                      style="width: 200px"
                      type="number"
                      v-model.number="insuranceData.singleBoxMax"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="总货值(CNY):"
                    prop="totalMount"
                    label-width="150px"
                  >
                    <el-input
                      style="width: 200px"
                      type="number"
                      v-model.number="insuranceData.totalMount"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item
                  label="总货值(CNY):"
                  prop="totalMount"
                  label-width="150px"
                  v-show="insuranceData.totalMountCny"
                  style="margin: 0"
                >
                  <el-input
                    disabled
                    style="width: 200px"
                    type="number"
                    v-model.number="insuranceData.totalMountCny"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item> -->
                  <el-form-item
                    label="总重量(KG):"
                    prop="weightTotal"
                    label-width="150px"
                    v-if="insuranceData.chargeType == 'KG'"
                    style="margin-top: 20px"
                  >
                    <el-input
                      disabled
                      style="width: 200px"
                      type="number"
                      v-model.number="insuranceData.weightTotal"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0px">
                    <el-checkbox
                      @change="changeAllChecked()"
                      v-model="isChosedSafe"
                      >我已阅读并同意<span
                        style="
                          color: #5ab53c;
                          cursor: pointer;
                          text-decoration: underline;
                          margin: 0;
                          padding: 0;
                          margin-left: 5px;
                        "
                        @click.stop.prevent="openPolicy()"
                        >《投保服务协议》</span
                      ></el-checkbox
                    >
                  </el-form-item>

                  <div
                    style="
                      width: 300px;
                      display: flex;
                      justify-content: center;
                      gap: 20px;
                      margin-top: 10px;
                    "
                  >
                    <div class="count_center" style="box-sizing: border-box">
                      <el-button
                        :class="
                          !showClickNext
                            ? 'animate__animated  animate__headShake  animate__bounceIn animate__pulse'
                            : ''
                        "
                        @click="submitForm('ruleForm')"
                        style="width: 100%; background: #5ab53c; color: #ffffff"
                        >确认</el-button
                      >
                    </div>

                    <div class="count_center" style="box-sizing: border-box">
                      <el-button
                        @click="resetForm('ruleForm')"
                        style="width: 100%; background: #fff; color: #303133"
                        >重置</el-button
                      >
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
            <div
              v-if="item.remark && item.checked"
              style="float: right; color: #ccc; padding-right: 25px"
            >
              *{{ item.remark }}
            </div>
          </div>
        </div>
        <div v-show="formData.feeItemDTOS.length == 0" style="padding: 20px">
          <el-alert
            :closable="false"
            :title="$t('i18n_no_sevice_add')"
            type="warning"
            :description="$t('i18n_no_service_add_continue')"
            show-icon
          >
          </el-alert>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{ $t("i18n_cost_calculation") }}
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">{{ $t("i18n_shipping_cost") }}</p>
            <p
              class="coutText"
              v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}</span
              >
              <span style="margin-left: 10px">({{ item.calDesc }})</span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="THFdata.checked"
          >
            <p class="tit">{{ $t("i18n_pickup_fee") }}</p>
            <p class="coutText">
              <span class="littit">{{
                $t("i18n_pickup_at_original_port")
              }}</span>
              <span class="fontString"
                >{{ THFdata.currency }}{{ THFdata.amount }}</span
              >
              <span
                class="littit"
                style="float: left; width: 100%"
                v-if="THFdata.maxKilometer > 0"
                >({{ THFdata.minKilometer }}--{{ THFdata.maxKilometer }})
                {{ $t("i18n_Kilometers") }}</span
              >
            </p>
          </div>
          <!-- 暂时隐藏全境派尾程派送费 -->
          <!-- <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-if="this.isGlobalDelivery && !this.isGlobalSea"
          >
            <p class="tit">{{ $t("i18n_global_delivery_cost") }}</p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ GlobalDelivery.currency }}{{ GlobalDelivery.amount }}</span
              >
              <span style="margin-left: 10px"
                >{{ "(" }}{{ GlobalDelivery.calDesc }}{{ ")" }}</span
              >
            </p>
          </div> -->

          <div class="Item_Right" v-if="formData.totalExpense">
            <p class="tit">{{ $t("i18n_Value_Added_Service_Fee") }}</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData.feeItemDTOS"
              :key="index"
              v-show="item.checked"
            >
              <!-- <span class="littit">{{ item.feeName }}</span> -->
              <span class="littit" v-if="item.feeCode === 'CLEF'">{{ $t('i18n_customs_declaration_with_tax_refund') }}</span>
              <span class="littit" v-else>{{ item.feeName }}</span>
              <span class="fontString"
                >{{ item.currency }}&nbsp;&nbsp;{{ item.amount }}&nbsp;&nbsp;({{
                  item.calDesc
                }})</span
              >
            </div>
            <div
              class="coutText animate__animated animate__bounceInRight"
              style="color: #ff3030"
            >
              <span class="littit" style="color: #ff3030"
                >{{ $t("i18n_subtotal") }}:</span
              >
              <span class="fontString">{{ formData.totalExpense }}</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText" style="justify-content: flex-start; gap: 10px">
              <span class="littit">{{ $t("i18n_total_cost") }}</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span>
                  <span class="fontString" v-show="item.currency != ''">
                    {{ item.currency }}
                  </span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                  >
                    {{ item.amount }}
                  </span>
                </span>
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_Covert_to_CNY") }}</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
          <div class="goodsValueCount">
            <div class="goodsValue_name">货值统计</div>
            <div class="goodsValue_fat">
              <div class="goodsValue_box">箱数:{{ getBoxNum }} 箱</div>
              <div class="goodsValue_value">货值:{{ getGoodsValue }} USD</div>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()">{{
              $t("i18n_Previousstep")
            }}</el-button>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <div
              :title="
                this.showClickNext && this.bigCusShowClickNext
                  ? ''
                  : '请重新确认保价信息'
              "
              @click="pathToNext()"
              :style="{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '4px',
                cursor: 'pointer',
                width: '100%',
                height: '40px',
                background:
                  this.showClickNext && this.bigCusShowClickNext
                    ? '#5ab53c'
                    : 'gray',
                color: '#ffffff'
              }"
            >
              {{ $t("i18n_Next_step") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 协议条款弹窗 -->
    <el-dialog center :visible.sync="policyDialog" width="50%">
      <p style="width: 100%" v-html="policyContent || '暂无数据'"></p>
    </el-dialog>
    <!-- <el-loading :fullscreen="true" :visible="calLoading"></el-loading> -->
    <el-button
      type="primary"
      style="opacity: 0; cursor: pointer"
      v-loading.fullscreen.lock="calLoading"
    >
      指令方式
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // loading interval
      loadingInterval: '',
      // 是否展示保价无忧模块
      showInsurance: false,
      // 投保服务协议内容
      policyContent: "",
      // 投保服务协议
      policyDialog: false,
      // 保险比例是否存在
      secureShowData: true,
      // 大客户下一步是否能正常点击
      bigCusShowClickNext: true,
      // 下一步是否能正常点击
      showClickNext: true,
      // 保险id
      toWarehouseId: '',
      // 保险code
      transportTypeCode: '',
      moneytype: [],
      formData: {
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      auto_fixed: false,
      showMoneythst: {
        //当前展示币种
        currencyTo: "",
        rate: "",
      },
      FBATransmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      isGlobalDelivery: false, //是否属于全境派送产品
      isGlobalSea: false, //是否是全境派送海运产品
      GlobalDelivery: {
        //全境派送费
        amount: "",
        cnyamount: "",
        currency: "",
        piece: "",
        price: "",
        calDesc: "",
      },
      msgFormSon: {},
      newTihuoarr: "", //需展示的提货地址
      todoordate: {},
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
      // 是否勾选投保服务协议
      isChosedSafe: true,
      insuranceData: {
        // 保额比例
        insuredAmount: '',
        // 品名
        goodsName: "",
        // 箱数
        amount: '',
        // PCS(物品总件数)
        pcsAmount: '',
        // 单箱最高货值
        singleBoxMax: '',
        // 单箱最低货值
        singleBoxMin: '',
        // 总货值(USD)
        totalMount: '',
        // 总货值(CNY)
        totalMountCny: ""
      },
      // 保额比例
      insuredAmountList: [],

      rules: {
        insuredAmount: [
          { required: true, message: '请选择保险比例', trigger: 'change' },
        ],
        pcsAmount: [
          { required: true, message: '请输入PCS(商品件数)', trigger: 'blur' },
          { pattern: /^([1-9][\d]{0,4})$/, message: 'PCS(商品件数)不得大于99999、小于等于0', trigger: 'blur' }
        ],
        singleBoxMax: [
          { required: true, message: '请输入单箱最高货值', trigger: 'blur' },
          { pattern: /^(?:[1-9]\d*(?:\.\d+)?|\d{1,}\.\d+)$/, message: '单箱最高货值不得小于等于0', trigger: 'blur' }
        ],
        singleBoxMin: [
          { required: true, message: '请输入单箱最低货值', trigger: 'blur' },
          { pattern: /^(?:[1-9]\d*(?:\.\d+)?|\d{1,}\.\d+)$/, message: '单箱最低货值不得小于等于0', trigger: 'blur' }
        ],
        totalMount: [
          { required: true, message: '请输入总货值', trigger: 'blur' },
          { pattern: /^(?:[1-9]\d*(?:\.\d+)?|\d{1,}\.\d+)$/, message: '总货值不得小于等于0', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    comIsFitBigCus: {
      handler(newVal, oldVal) {
        // //console.log("是否隐藏保价无忧模块", newVal)

      },
      deep: true
    },
    comFeeItemDTOS: {
      handler(newVal, oldVal) {
        // 全部不选可下一步
        if (Array.isArray(this.formData.feeItemDTOS) && this.formData.feeItemDTOS.length > 0) {
          let isAllNotChose = this.formData.feeItemDTOS.every(item => {
            return !item.checked
          })
          if (isAllNotChose) {
            this.showClickNext = true
          }
          // 保险不选可下一步
          let findIndex = this.formData.feeItemDTOS.findIndex(item => { return item.feeCode == 'INS' })
          if (!!this.formData.feeItemDTOS[findIndex] && !this.formData.feeItemDTOS[findIndex].checked) {
            this.showClickNext = true
          }
        } else {
          this.showClickNext = true
        }
      },
      deep: true
    },
    comTotalInfo(newVal, oldVal) {
      if (this.formData.feeItemDTOS.length == 0) {
        this.showClickNext = true
        return
      }
      if (newVal !== oldVal && this.showClickNext) {
        this.showClickNext = false
      }
    }
  },

  computed: {
    // 箱数统计
    getBoxNum() {
      return this.$store.state.goodsValueCount.boxNum
    },
    // 货值统计
    getGoodsValue() {
      return this.$store.state.goodsValueCount.proValue
    },
    // 计算loading状态
    calLoading() {
      return this.$store.state.productLoading
    },
    // 综合判断是否隐藏保价无忧模块--是大客户、电商、非陆运--在隐藏保价无忧模块的同时，重新计算预估保费模块
    comIsFitBigCus() {
      //  是否大客户
      let isBigCustomer = this.$store.state.isBigCustomer
      // 是否电商
      let getProductType = this.calIndexTab()
      let isOnRetailers = getProductType.sonType == 3
      // 是否陆运
      let isLandTrans = localStorage.getItem("transportTypeCode") == 'LY'
      return isBigCustomer && isOnRetailers && !isLandTrans
    },
    // 监听增值服务勾选
    comFeeItemDTOS() {
      return this.formData.feeItemDTOS
    },
    // 监听保额比例、PCS、单箱最低货值、单箱最高货值、总货值
    comTotalInfo() {
      return this.insuranceData.insuredAmount + this.insuranceData.pcsAmount + this.insuranceData.singleBoxMax + this.insuranceData.singleBoxMin + this.insuranceData.totalMount
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      let GlobalDeliveryCny = 0; //全境派送费
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   //如果有全境派送费
      //   GlobalDeliveryCny = this.GlobalDelivery.cnyamount ? +this.GlobalDelivery.cnyamount : 0;
      // }

      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      Totalmoney = FBATransmoney + THFmoney + GlobalDeliveryCny + this.formData.amount;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let monetTypelist = []; //当前勾选的币种
      let totalMolist = []; //新对象
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   totalFeiyong.push(JSON.parse(JSON.stringify(this.GlobalDelivery))); //全境派送
      // }
      this.formData.feeItemDTOS.forEach((item) => {
        if (item.checked && item.feeCode != 'INS') {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    // 整合首页参数
    calIndexTab() {
      let getProductType = JSON.parse(localStorage.getItem("productType"))
      if (!getProductType) {
        getProductType = JSON.parse(this.$store.state.productType)
        if (!getProductType) {
          return this.returnIndex()
        }
        return getProductType
      }
      return getProductType
    },
    // 返回首页
    returnIndex() {
      this.$message.warning("数据异常,请重新下单!")
      localStorage.clear();
      this.$router.push("/index/placeOrder/placeIndex");
      this.$store.state.Authorization = null;
    },
    // 获取是否是大客户
    async getIsBigCustomer() {
      let self = this
      return new Promise((resolve, reject) => {
        let boxList = JSON.parse(localStorage.getItem("boxLIst"))
        let params = {
          // 客户id
          customerId: self.$store.state.Authorization.customerid,
          // 运输方式
          transportType: JSON.parse(localStorage.getItem('transportTypeCode')),
          // 电商
          businessType: 'EC',
          // 体积
          cbm: 0,
          // 重量
          weight: 0,
          // 目的国id
          countryId: localStorage.getItem('toCountryId'),
          // 箱子数量
          boxNum: boxList.length
        }
        self.axios.post('/insurance/getBindingPackageStatus', params)
          .then(res => {
            if (res.data.data.isBigCustomer) {
              self.$store.commit("setIsBigCustomer", true)
              resolve(true)
            } else {
              self.$store.commit("setIsBigCustomer", false)
              resolve(false)
            }
          })
      })
    },
    // 计算预估保费
    async calPreSafeFee() {
      let boxList = JSON.parse(localStorage.getItem("boxLIst"))
      let params = {
        // 客户id
        customerId: this.$store.state.Authorization.customerid,
        // 运输方式
        transportType: JSON.parse(localStorage.getItem('transportTypeCode')),
        // 电商
        businessType: 'EC',
        // 体积
        cbm: 0,
        // 重量
        weight: 0,
        // 目的国id
        countryId: localStorage.getItem('toCountryId'),
        // 箱子数量
        boxNum: boxList.length
      }
      let pcs = 0
      for (let i = 0; i < boxList.length; i++) {
        params.cbm += boxList[i].cbm
        params.weight += boxList[i].weight
        if (boxList[i].goodsDTOList.length > 0) {
          boxList[i].goodsDTOList.map((item) => {
            pcs += item.num
          })
        }
      }
      await this.axios.post('/insurance/calculateInsByBigCus', params)
        .then(res => {
          //console.log("重新计算后的费用", res)
          if (res.data.code == 200) {
            this.$nextTick(() => {
              // this.$set(this.formData.feeItemDTOS, this.formData.feeItemDTOS.length, {
              //   amount: res.data.data.feeCNY,
              //   basePriceDesc: "",
              //   calDesc: res.data.data.calDesc,
              //   checked: true,
              //   currency: 'CNY',
              //   declarePriceDesc: '',
              //   feeCode: 'INS',
              //   feeName: '预估保费',
              //   iconUrl: '',
              //   num: '',
              //   priceDesc: '',
              //   remark: '预估保费'
              // })
              // this.formData.totalExpense += res.data.data.feeCNY
              // this.formData.amount += res.data.data.feeCNY
              // res.data.data.pcs = pcs
              localStorage.setItem('finaInsuranceDTO', JSON.stringify(res.data.data))
            })
          } else if (res.data.code == 403) {
            this.$message.warning(res.data.message)
            this.$nextTick(() => {
              this.bigCusShowClickNext = false
            })
          }
        })
    },
    // 获取货物类型
    async getBoxType() {
      // 缓存箱子详情数据
      let productType = this.calIndexTab()
      // 物流产品/电商才能缓存箱子数据
      if (productType.fatType == 0 && productType.sonType == 3) {
        let podCountryId = localStorage.getItem('toCountryId')
        let boxDTOS = JSON.parse(localStorage.getItem('boxLIst'))
        boxDTOS.map(item => {
          if (!!item.goodstypeid) {
            item.goodsTypeId = item.goodstypeid
            delete item.goodstypeid
          }
        })
        let params = {
          podCountryId: podCountryId,
          boxDTOS: boxDTOS
        }
        await this.axios.post('/FBAfee/getInsuranceType', params)
          .then(res => {
            if (res.data.code == 200 && res.data) {
              localStorage.setItem('boxInfo', JSON.stringify(res.data.data))
            }
          })
          .catch(res => {
          })
      }
    },
    // 投保服务协议
    openPolicy() {
      this.policyDialog = true
    },
    // 切换保险协议
    changeAllChecked() {
      if (this.showClickNext && !this.isChosedSafe) {
        this.showClickNext = false
      }
      if (!this.showClickNext && this.isChosedSafe) {
        this.showClickNext = true
      }

    },
    // 校验保险无忧表单提交
    submitForm(formName) {
      this.$refs.ruleForm[0].validate((valid) => {
        if (valid) {
          if (this.insuranceData.singleBoxMax < this.insuranceData.singleBoxMin) {
            this.$message({
              showClose: true,
              message: "单箱最高货值不能小于最低货值",
              type: "warning",
            });
            return
          }
          if (this.insuranceData.totalMount < this.insuranceData.singleBoxMax) {
            this.$message({
              showClose: true,
              message: "总货值不能小于单箱最高货值",
              type: "warning",
            });
            return
          }
          if (!this.isChosedSafe) {
            this.$message({
              showClose: true,
              message: '请同意并勾选投保服务协议',
              type: 'warning'
            })
            return
          }

          let params = {

            toWarehouseId: this.toWarehouseId,
            transportType: this.transportTypeCode,
            additionRate: this.insuranceData.insuredAmount,
            goods: this.insuranceData.goodsName,
            pieces: JSON.stringify(this.insuranceData.amount),
            valueLowestUSD: Number(this.insuranceData.singleBoxMin),
            valuehighestUSD: Number(this.insuranceData.singleBoxMax),
            valueTotalUSD: Number(this.insuranceData.totalMount),
            pcs: Number(this.insuranceData.pcsAmount)
          }

          let productType = this.calIndexTab()
          if (productType.fatType == 0 && productType.sonType == 3) {
            params.podCountryId = this.insuranceData.podCountryId
            params.chargeType = this.insuranceData.chargeType
            params.weightTotal = this.insuranceData.weightTotal
          }

          this.axios.post(`/insurance/calculateInsurance`, params)
            .then(res => {
              if (res.data.code == 200 && res.data.data) {
                res.data.data.checked = true
                localStorage.setItem('finaInsuranceDTO', JSON.stringify(res.data.data))
                this.insuranceData.totalMountCny = res.data.data.valueTotalCNY
                //计算费用
                let that = this;
                let params = {};
                this.formData.feeItemDTOS.forEach((item, index) => {
                  if (item.feeCode == 'INS') {
                    item.currency = "CNY"
                    item.amount = res.data.data.feeCNY
                    item.calDesc = res.data.data.calDesc
                  }
                });
                // this.formData.feeItemDTOS[1].currency = "CNY"
                // this.formData.feeItemDTOS[1]['amount'] = res.data.data.feeCNY
                // this.formData.feeItemDTOS[1]['calDesc'] = res.data.data.calDesc
                params = {
                  customerId: JSON.parse(sessionStorage.getItem("Authorization"))
                    .customerid, //客户id
                  inWarehouseId: JSON.parse(localStorage.getItem("fromFABck")).id,
                  feeItemDTOS: this.formData.feeItemDTOS,
                  cbm: this.$route.query.PathCBM,
                  toWarehouseId: JSON.parse(localStorage.getItem("toFABck")).id,
                  transportTypeCode: JSON.parse(
                    localStorage.getItem("transportTypeCode")
                  ),
                };
                this.axios
                  .post(`/FBAfee/calFBAFeeItems`, params)
                  .then((res) => {
                    if (res.data.code == "200") {

                      let Newarray = res.data.data.feeItemDTOS;
                      that.formData.totalExpense = res.data.data.totalExpense;
                      that.formData.amount = res.data.data.amount;
                      // that.formData.amount = that.newArray
                      this.formData.feeItemDTOS.forEach((item, index) => {
                        if (Newarray[index].feeCode == item.feeCode) {
                          item.amount = Newarray[index].amount;
                          item.calDesc = Newarray[index].calDesc;
                        }
                      });
                    } else {
                    }
                  })
                  .catch((res) => { });

                this.showClickNext = true
              }
              else {
                this.$message({
                  showClose: true,
                  message: `${res.data.message}`,
                  type: "warning",
                });
                this.showClickNext = false
              }
            })
            .catch(res => {
              this.$message({
                showClose: true,
                message: `${res.data.message}`,
                type: "warning",
              });
              this.showClickNext = false
            })

        } else {
          return false;
        }
      });

    },
    // 重置保险无忧表单提交
    resetForm(formName) {
      this.$refs.ruleForm[0].resetFields();
      this.showClickNext = false
    },
    pathToNext() {
      if (this.showClickNext && this.bigCusShowClickNext) {
        if (this.isChosedSafe) {
          let File = true
          try {
            this.formData.feeItemDTOS.forEach((item) => {
              if (item.feeCode == "INS" && !item.checked) {
                let finaInsuranceDTO = {
                  calDesc: "",
                  checked: false,
                  feeCNY: "",
                  insuranceQuoteId: "",
                  insuranceRate: "",
                  isSpecialGoods: "",
                  specialGoods: null,
                  totalGoods: "",
                  totalPiece: "",
                  valueAvgCNY: "",
                  valueLowestUSD: "",
                  valueRate: "",
                  valueTotalCNY: "",
                  valueTotalUSD: "",
                  valuehighestUSD: "",
                }
                localStorage.setItem('finaInsuranceDTO', JSON.stringify(finaInsuranceDTO))
              }
              if (item.checked && item.remark != '预估保费') {
                if (!item.num)
                  throw this.$message({
                    showClose: true,
                    message: this.$t("i18n_fill_correct_price"),
                    type: "error",
                  });
              }
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            localStorage.setItem("FeeLIst", JSON.stringify(this.formData)); //增值服务
            this.$router.push({
              name: "Fbaconsignment",
            });
          }
        }
        else {

        }
      }
      else {
        if (!this.bigCusShowClickNext) {
          return this.$message.warning("大客户请先绑定保险套餐")
        }
        if (!this.isChosedSafe) {
          this.$message({
            showClose: true,
            message: "请阅读并同意《投保服务协议》",
            type: "warning",
          });
        }
        else {
          this.$message({
            showClose: true,
            message: "请重新提交保险表单或取消保险服务",
            type: "warning",
          });
        }

      }

    },
    handleChange(src) {
      this.saveCountryBox()
      // 保险无忧
      if (src.feeCode == "INS" && src.checked == false) {
        this.showClickNext = true
      }
      else if (src.feeCode == "INS" && src.checked == true) {
        this.showClickNext = false
        if (!this.secureShowData) {
          this.$message({
            showClose: true,
            message: "暂无保险报价,请核实",
            type: "warning",
          });
        }

      }
      //计算费用
      let that = this;
      let params = {};
      if (src.feeCode == "INS" && src.checked == true) {
        this.formData.feeItemDTOS.forEach((item, index) => {
          if (item.feeCode == "INS" && item.remark != '预估保费') {
            item.currency = "CNY"
            item.amount = 0
            item.calDesc = 0
          }
        });
      }
      // this.formData.feeItemDTOS[1].currency = "CNY"
      // this.formData.feeItemDTOS[1]['amount'] = 0
      params = {
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        inWarehouseId: JSON.parse(localStorage.getItem("fromFABck")).id,
        feeItemDTOS: this.formData.feeItemDTOS.filter(item => { return item.remark != '预估保费' }),
        cbm: this.$route.query.PathCBM,
        toWarehouseId: JSON.parse(localStorage.getItem("toFABck")).id,
        transportTypeCode: JSON.parse(
          localStorage.getItem("transportTypeCode")
        ),
      };
      this.axios
        .post(`/FBAfee/calFBAFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            let Newarray = res.data.data.feeItemDTOS;
            that.formData.totalExpense = res.data.data.totalExpense;
            // 额外计算预估保费
            let getExtralFee = that.formData.feeItemDTOS.filter(item => { return item.remark == '预估保费' })

            that.formData.amount = res.data.data.amount;
            //console.log("getExtralFee", getExtralFee)
            if (Array.isArray(getExtralFee) && getExtralFee.length > 0) {
              that.formData.amount += getExtralFee[0].amount
              that.formData.totalExpense = "CNY" + that.formData.amount
            }
            // that.formData.amount = that.newArray
            this.formData.feeItemDTOS.forEach((item, index) => {
              if (Newarray[index].feeCode == item.feeCode) {
                item.amount = Newarray[index].amount;
                item.calDesc = Newarray[index].calDesc;
              }
            });
          } else {
          }
        })
        .catch((res) => { });

    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },

    pathToback() {
      this.$router.go(-1);
    },
    async getShowcount() {
      let that = this;
      let params = {};
      params = {
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        inWarehouseId: JSON.parse(localStorage.getItem("fromFABck")).id,
        toWarehouseId: JSON.parse(localStorage.getItem("toFABck")).id,
        transportTypeCode: JSON.parse(
          localStorage.getItem("transportTypeCode")
        ),
        checkSpecialProduct: JSON.parse(localStorage.getItem('boxInfo')).checkSpecialProduct
      };
      await this.axios
        .post(`/FBAfee/getFBAFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            if (localStorage.getItem("FeeLIst")) {
              that.formData = JSON.parse(localStorage.getItem("FeeLIst"));
              this.handleChange();
            } else {
              that.formData.feeItemDTOS = res.data.datas;
              // 特殊逻辑-- 是否隐藏保价无忧模块
              if (this.comIsFitBigCus && Array.isArray(that.formData.feeItemDTOS) && that.formData.feeItemDTOS.length > 0) {
                //  隐藏保价无忧模块
                let findIndex = that.formData.feeItemDTOS.findIndex(item => { return item.feeCode == 'INS' && item.remark != '预估保费' })
                if (findIndex > -1) {
                  //console.log("裁剪了一次", that.formData.feeItemDTOS)
                  that.formData.feeItemDTOS.splice(findIndex, 1)
                  //console.log("裁剪后的数据", that.formData.feeItemDTOS)
                }
              }
              // //console.log("that.formData.feeItemDTOS",that.formData.feeItemDTOS)
            }
          } else {
          }
        })
        .catch((res) => { });
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
    // 处理上一页箱子信息
    getBoxData() {
      // 箱子信息
      let boxList = []
      // 商品种类
      let goodsArray = []
      boxList = JSON.parse(localStorage.getItem("boxLIst"))
      if (boxList.length > 0) {
        // //console.log("商品种类", boxList)
        // 赋值箱子数量
        this.insuranceData.amount = boxList.length;
        for (let i = 0; i < boxList.length; i++) {
          if (boxList[i].goodsDTOList.length > 0) {
            boxList[i].goodsDTOList.map((item) => {
              goodsArray.push(item.namec)
              this.insuranceData.pcsAmount = Number(this.insuranceData.pcsAmount) + item.num
            })
          }
        }
        // 箱子种类去重
        goodsArray = [...new Set(goodsArray)]
        if (goodsArray.length > 0) {
          this.insuranceData.goodsName = goodsArray.join('、')
        }
      }
    },
    //获取保险无忧保额比例
    getSecureCount() {
      this.axios.get(`/insurance/getInsuranceRateList/${this.toWarehouseId}/${this.transportTypeCode}`)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.datas) {
              this.secureShowData = true
              res.data.data.datas.map(item => {
                this.insuredAmountList.push({
                  label: item,
                  value: Number(item.replace(/%/g, '')) / 100
                })
              })
            }
            else {
              this.secureShowData = false
            }

          }
        })
        .catch(res => {
          // //console.log("res", res)
        })
    },
    // 获取服务协议
    getFbaService() {
      let that = this
      this.axios.get(`/insurance/getEIA`)
        .then(res => {
          if (res.status == 200) {
            that.policyContent = res.data.data.data
          }
        })
        .catch(res => {
          that.policyContent = "暂无数据"
        })
    },
    /**
     * 缓存目的国，箱子数据
     * */
    saveCountryBox() {
      // 费用类型
      let productType = this.calIndexTab()
      // //console.log("productType", productType)
      if (productType.fatType == 0 && productType.sonType == 3) {
        // 目的国
        let toCountryId = JSON.parse(localStorage.getItem('toCountryId'))
        // 箱子信息
        let boxInfo = JSON.parse(localStorage.getItem('boxInfo'))
        // 缓存进保险数据中
        this.insuranceData.podCountryId = toCountryId
        this.insuranceData.chargeType = boxInfo.chargeType
        this.insuranceData.weightTotal = boxInfo.totalWeight
        this.showInsurance = boxInfo.checkSpecialProduct
        // //console.log(" this.insuranceData.weightTotal ", this.insuranceData)
      }
    }
  },
  created() {
    // 获取服务协议
    this.getFbaService()
    // 初始化清空保险返回数据
    localStorage.setItem('finaInsuranceDTO', "")
    // 存储code、id
    this.transportTypeCode = JSON.parse(localStorage.getItem("transportTypeCode"))
    this.toWarehouseId = JSON.parse(localStorage.getItem("toFABck")).id
    // 处理上一页箱子信息，截取商品类型、箱子数量
    this.getBoxData()

    // 获取保险无忧保额比例
    this.getSecureCount()

    if (localStorage.getItem("FBATransmoney")) {
      //运输费
      this.FBATransmoney = JSON.parse(localStorage.getItem("FBATransmoney"));
    }
    if (localStorage.getItem("THFdata")) {
      //提货费
      this.THFdata = JSON.parse(localStorage.getItem("THFdata"));
    }
    if (localStorage.getItem("GlobalDelivery")) {
      //跨境运输费
      this.GlobalDelivery = JSON.parse(localStorage.getItem("GlobalDelivery"));
    }
    // 是否为全境派送海运
    this.isGlobalSea = this.$store.state.productInfo.transportTypeCode == 'HY' && this.$store.state.productInfo.isGlobalDelivery
    if (localStorage.getItem("isGlobalDelivery")) {
      this.isGlobalDelivery = JSON.parse(localStorage.getItem("isGlobalDelivery"));
    }
  },
  async mounted() {
    // window.addEventListener('beforeunload', function () {
    //   if (this.calLoading) {
    //     this.$store.commit("setProductLoading", false)
    //     this.returnIndex()
    //   }
    // })
    // const loading = this.$loading({
    //   lock: true,
    //   text: "数据加载中,请稍候...",
    //   spinner: "el-icon-loading",
    //   background: "rgba(0, 0, 0, 0.7)",
    // });
    this.$store.commit("setProductLoading", true)
    this.loadingInterval = setTimeout(() => {
      this.$store.commit("setProductLoading", false)
      this.returnIndex()
    }, 20000);
    await this.getBoxType()
    // await this.getIsBigCustomer()
    this.getIsBigCustomer()
      .then(async (res) => {
        // console.log("是否是大客户", res)
        if (res) {
          await this.getShowcount();
          //监听滚动
          window.addEventListener("scroll", this.onScroll);
          this.$nextTick(() => {
            // 隐藏保价无忧模块后计算预估保费
            if (this.comIsFitBigCus && !this.formData.feeItemDTOS.some(item => { return item.remark == '预估保费' })) {
              this.calPreSafeFee()
            }
          })
        } else {
          await this.getShowcount();
          //监听滚动
          window.addEventListener("scroll", this.onScroll);
        }
      })
      .finally(res => {
        // loading.close()
        clearTimeout(this.loadingInterval)
        this.loadingInterval = ''
        this.$store.commit("setProductLoading", false)
      })
  }
  // beforeDestroy() {
  //   // console.log("进来了")
  //   if (this.calLoading) {
  //     clearTimeout(this.loadingInterval)
  //     this.loadingInterval = ''
  //     this.$store.commit("setProductLoading", false)
  //     this.returnIndex()
  //   }
  // }
};
</script>
<style scoped>
@keyframes changeBtn {
  from {
    background: gray;
  }
  to {
    background: #5ab53c;
  }
}
/* 添加按钮渐变特效 */
.click_active {
  /* animation: changeBtn 1s ease-in-out; */
}
.fontString {
  font-weight: bold;
}

.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 900px;
}

/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.LR_center_insurance {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
}

.LR_center_box {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}

.LR_center_boxItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 400px;
  padding: 25px 25px 0 25px;
  box-sizing: border-box;
}

.LR_center_itemTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
}

/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}

.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}

.Item_Right {
  float: left;
  overflow-x: hidden;
}

.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}

.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: hidden;
}

.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}

.center_wrap {
  width: 1280px;
  margin: 0 auto;
}

.Item_list {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}

.wrap_R {
  float: right;
  width: 380px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}

/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}

.OrderDetails::-webkit-scrollbar {
  width: 3px;
}

.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}

.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}

/* 货值统计 */
.goodsValueCount {
  box-sizing: border-box;
  width: 100%;
  float: left;
  padding-top: 10px;
  color: #f86670;
}
.goodsValue_fat {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}
.goodsValue_name {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/Fbaservice.vue